import { MediaServices } from "./MediaServices";

export { CameraPhoto } from "./CameraPhoto";
export const FACING_MODES = MediaServices.FACING_MODES;
export const IMAGE_TYPES = MediaServices.IMAGE_TYPES;
export { _getDebugPlatformInfo } from "./MediaServices";
export type { CameraPhotoConfig } from "./CameraPhoto";
export { CameraPhoto as default } from "./CameraPhoto";
